import React from 'react';
import PropTypes from 'prop-types';
import FormWrapper from '../../components/form-wrapper';

class SignupForm extends React.Component {
  constructor(props) {
    super(props);
    this.formConfig = [
      {
        label: 'E-mail',
        name: 'email',
        type: 'email',
        placeholder: 'E-mail',
        initialValue: '',
      },
      {
        label: 'Password',
        name: 'password',
        type: 'password',
        placeholder: 'Password',
        initialValue: '',
      },
      {
        label: 'Conferma Password',
        name: 'passwordConfirm',
        type: 'password',
        placeholder: 'Password',
        initialValue: '',
      },
      {
        label: 'Nome',
        name: 'name',
        type: 'text',
        placeholder: 'Nome',
        initialValue: '',
      },
      {
        label: 'Cognome',
        name: 'lastName',
        type: 'text',
        placeholder: 'Cognome',
        initialValue: '',
      },
    ];
    this.extraCheck = this.extraCheck.bind(this);
  }
  extraCheck(data) {
    if (data.password !== data.passwordConfirm) {
      return {
        password: ['Le password non coincidono'],
        passwordConfirm: ['Le password non coincidono'],
      };
    }
    return {};
  }
  save(data) {
    this.props.onSave(data);
  }
  render() {
    return (
      <FormWrapper
        config={this.formConfig}
        onValidSave={this.props.onSave}
        onCancel={this.props.onCancel}
        extraCheck={this.extraCheck}
        submitButtonLabel="Registrati"
        cancelButtonLabel="Sono già iscritto"
      />
    );
  }
}

SignupForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SignupForm;



// WEBPACK FOOTER //
// ./src/containers/user/signup-form.js